const list = {
    searchList: [
        {
            showField: "单号",
            entityField: "jobid",
            fieldType: "string",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: null,
            extractId: null,
            setField: null,
        },

    ],
}
export default list
